import { render, staticRenderFns } from "./fakulteyonetimkurulu.vue?vue&type=template&id=0778ff7f&"
import script from "./fakulteyonetimkurulu.vue?vue&type=script&lang=js&"
export * from "./fakulteyonetimkurulu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports